import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Globals } from "src/app/core/global";
import { paramsType } from "src/app/core/models/event-params.model";

declare let gtag: any;

@Injectable({
  providedIn: 'root'
})

export class EventsService {

  constructor(private globals: Globals, private http: HttpClient) { }

  eventStart(params: paramsType) {

    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', }) }

      params.eventType = params.eventType || null;
      params.sessionKey = params.sessionKey || this.globals.generateSessionId() || null;
      params.deviceUuid = params.deviceUuid || this.globals.generateDeviceId() || null;
      params.serviceId = params.serviceId || this.globals.serviceId || null;
      params.operatorId = params.operatorId || this.globals.operatorId || null;
      params.msisdn = params.msisdn || (localStorage.getItem('u') && JSON.parse(localStorage.getItem('u')).m ? atob(JSON.parse(localStorage.getItem('u')).m)  : null);
      params.partnerId = params.partnerId || null;
      params.productId = params.productId || null;
      params.url = params.url || window.location.href;
      params.referer = params.referer || document.referrer;
      params.sitename = params.sitename || window.location.host;
      params.userAgent = params.userAgent || navigator.userAgent;
      params.userInput = params.userInput || null;
      params.requestData = params.requestData || null;
      params.responseData = params.responseData || null;
      params.userDataReceived = params.userDataReceived || null;
      params.userIp = params.userIp || null;
      params.subSource = params.subSource || null;
      params.useSession = params.useSession || false;
      params.eventResult = params.eventResult || null;
      params.downloadUrl = params.downloadUrl || null;
      params.catId = params.catId || null;
      params.mediaId = params.mediaId || null;
      params.binId = params.binId || null;
      params.channelId = params.channelId || null;
      params.trackingId = params.trackingId || null;
      params.subSubSource = params.subSubSource || null;
      params.eventSubType = params.eventSubType || null;
      params.partnerName = params.partnerName || null;
      params.productName = params.productName || null;
      params.offerId = params.offerId || null;
      params.offerName = params.offerName || null;
      params.trafficTypeId = params.trafficTypeId || null;
      params.trafficTypeName = params.trafficTypeName || (sessionStorage.getItem('u') && JSON.parse(sessionStorage.getItem('u')).dt == true ? '3G'  : 'WIFI');
      params.tierId = params.tierId || null;
      params.tierName = params.tierName || null;
      params.redirectUrl = params.redirectUrl || null;
      params.inputId = params.inputId || null;
      params.inputName = params.inputName || null;
      params.prizeId = params.prizeId || null;
      params.prizeName = params.prizeName || null;

   

    gtag('event', params.triggerType,{'event_category': params.eventType})

    // console.debug(body);
    // !!this.globals.eventRegist.analyticsId && params.triggerType && gtag('event', params.triggerType, { 'event_category': params.eventType });
    if (this.globals.eventRegist.timweBi && window.location.hostname) {
      this.http.post(`${this.globals.baseUrlEvents}/events/${params.eventType}`, params, httpOptions).toPromise();
    }
  }

}
